import React from "react";
import i18next from "i18next"
import { getWitnessType } from "../../../../common/getString"
import { useTranslation } from "react-i18next";
import "../style.css";

interface IWitnessDetailsAndCommentsProps {
  witness_full_name?: string;
  host_name?: string;
  witness_type?: string;
  comments_for_guests?: string;
  witness_presentation_details?: string;
}

const WitnessDetailsAndComments = ({
    witness_full_name,
    host_name,
    witness_type,
    comments_for_guests,
    witness_presentation_details
  }: IWitnessDetailsAndCommentsProps) => {
    const { t } = useTranslation();
    return (
      <>
      {
        comments_for_guests && <p className="witness-comments">{ comments_for_guests }</p>
      }
      {
        witness_full_name && (
          <>
            <p className={witness_presentation_details ? 'witness-details' : 'witness-details-no-presentation'}>
            {i18next.t('guests.salonSearchMap.witnessAndSalonDetails', {
                witnessName: witness_full_name,
                hostName: host_name,
                witnessType:t(getWitnessType(witness_type)),
            })}
            </p>
            {witness_presentation_details && (
              <p className="witness-presentation">{witness_presentation_details}</p>
            )}
          </>
        )
      }
    </>
    )
}
export default WitnessDetailsAndComments;